import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_describe_how_burning_waste_controlled'

export const dataPointDefinition = {
  retracedId: 'yes_describe_how_burning_waste_controlled',
  name: 'If yes, please describe how burning of waste is controlled:',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-4--10-1f',
      number: 'HS-GEN-23.1',
      dataType: 'string',
      masterType: 'Follow-up',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'follow-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[2],hs-4--10,Yes',
      machineShowHide: '[2],hs-4--10,1',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-4--10-1f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29380,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
